export default {
  B: 'B',
  H: 'H',
  E: 'E',
  S: 'S',
  KHG: 'KHG',
};
